import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute } from '@angular/router';
// import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
// import { GeneralService } from '../services/general.service';
import { NgxGaugeType } from 'ngx-gauge/gauge/gauge';
import { NgxGaugeCap } from 'ngx-gauge/gauge/gauge';

import {
  Chart,
  ChartConfiguration,
  ChartConfigurationCustomTypesPerDataset,
  ChartData,
  ChartOptions as ChartJSOptions,
} from 'chart.js';
import { GeneralService } from 'app/services/general.service';


@Component({
  selector: 'app-ModuelsDetails',
  templateUrl: './ModuelsDetails.component.html',
  styleUrls: ['./ModuelsDetails.component.css']
})

export class ModuelsDetailsComponent implements OnInit {
  @ViewChildren('canvas') canvases: QueryList<ElementRef>;
  @ViewChild('chart', { static: false }) chartRef: ElementRef;

  colorarray = [
    'rgba(255, 197, 0, 0.79)',
    'rgba(0, 17, 206, 0.79)',
    'rgba(0, 144, 151, 0.79)',
    'rgba(234,50,186,0.79)',
    'rgba(151,106,84,0.94)',
    'rgba(68,179,96,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,223,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)'];


  title = 'barchartApp';
  ////// gauge 
  gaugeType: NgxGaugeType = 'semi';
  gaugeValue: number = 68;
  gaugeAppendText: string = "%";
  cap: NgxGaugeCap = 'butt'
  markerConfig = {
    "0": {
      "color": "#555",
      "size": 5,
      "label": "0",
      "type": "line"
    },

    "20": {
      "color": "#555",
      "size": 5,
      "label": "20",
      "type": "line"
    }
    ,
    "40": {
      "color": "#555",
      "size": 5,
      "label": "40",
      "type": "line"
    },
    "60": {
      "color": "#555",
      "size": 5,
      "label": "60",
      "type": "line"
    },
    "80": {
      "color": "#555",
      "size": 5,
      "label": "80",
      "type": "line"
    },
    "100": {
      "color": "#555",
      "size": 5,
      "label": "100",
      "type": "line"
    }
  }
  LastauditsBranches: any[];
  labelsVchart: any[]=[];
  DataVchart: any[]=[];
  labelsHchart: any[]=[];
  DataHchart: any[]=[];

  DataSandtardcompilationdoughnut: any[]=[];
  ActionPlanOpen: any;
  ActionPlanClose: any;
  ActionPlanUnderProcess: any;
  //// end gauge




  constructor(private GeneralService: GeneralService,private firestore:AngularFirestore,private route: ActivatedRoute) {
  }

  ngOnInit() {
    
this.loadDataAndCharts();
  }
  // Example usage - update the gauge with a value of 90%
  onSelect(event: any) {
    console.log(event);
  }

  loadDataAndCharts() {
console.log(this.route.snapshot.paramMap.get("id"))
    this.GeneralService.getLastAuditOnBranch(this.route.snapshot.paramMap.get("id"))
      .then(data => {
        this.LastauditsBranches = data;
        console.log(data);
        return Promise.all(this.LastauditsBranches.map((_, index) => {
          console.log(_)
          return new Promise<void>(resolve => { // Specify Promise<void>
            setTimeout(() => {
              this.labelsVchart=[]
              this.DataVchart=[]
              this.labelsHchart=[]
              this.DataHchart=[]
              this.DataSandtardcompilationdoughnut=[];
              _.categories.forEach(categories => {
                this.labelsVchart.push(categories.categoryname)
                this.DataVchart.push(categories.percent)
              });
              _.departments.forEach((departments,index) => {
                this.DataHchart.push(departments.percent)
                this.labelsHchart.push(departments.departmentname)
//  this.DataHchart.push({
//   label:departments.departmentname ,
//   data: data, // Data now properly mapped to labels
//   backgroundColor: this.colorarray.slice(0, data.length),
//   borderColor: this.colorarray.slice(0, data.length),
//   borderWidth: 2,
//   maxBarThickness: 80, // ✅ Large bars without overlap
//   barPercentage: 0.8, // ✅ Adjust width to fit well
//   categoryPercentage: 0.8, 
//  })          
                // this.DataHchart.push(departments.percent)
                //  this.labelsHchart.push(departments.departmentname)
                // this.DataHchart.push({  label: departments.departmentname,
                //   data: departments.percent,
                //   backgroundColor: [this.colorarray[index]],
                //   borderWidth: 1,
                //   categoryPercentage: 0.8,
                //   barPercentage: 0.9
                // })
                
                

            
       


              });
              if(!_.Standardcompilation?.c){
                _.Standardcompilation.c=0
              }
              if(!_.Standardcompilation?.m){
                _.Standardcompilation.m=0
              }
              if(!_.Standardcompilation?.nc){
                _.Standardcompilation.nc=0
              }
              this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.c)
              this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.nc)
              this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.m)
              this.createvbarChart(index,this.labelsVchart,this.DataVchart);
              this.createhbarChart(index,this.labelsHchart,this.DataHchart);
              this.sandtardcompilationdoughnutChart(index,this.DataSandtardcompilationdoughnut)

              this.getActionPlanByAuditid(_.auditid,index)
              resolve(); 
            }, 0);
          });
        }));
        // Create charts after data is available and elements are rendered
       
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }




  

  







//   ngAfterViewInit() {
//     this.canvases.forEach((canvasRef, i) => {
//         const canvas = canvasRef.nativeElement as HTMLCanvasElement;
        
//         // Create a chart based on the current canvas and the corresponding data
//         const chart = new Chart(canvas, {
//             type: 'line',
//             data: {
//                 labels: ['Jan', 'Feb', 'Mar', 'Apr'],
//                 datasets: [{
//                     data: [10, 20, 30, 40],
//                     backgroundColor: 'rgba(75, 192, 192, 0.2)',
//                     borderColor: 'rgba(75, 192, 192, 1)',
//                     borderWidth: 1
//                 }]
//             }
//         });

//         // Update the chart data based on `LastauditsBranches[i]`
//         // Example: Assign the data you want to chart.datasets
//         chart.data.datasets[0].data = [10, 20, 30, 40];  // Replace with your data
//         chart.update();
//     });
// }








  // createhbarChart(index: number,labels:any,data:any): void {
  //   console.log(data,"this my data");
  //   console.log(labels,"this my data");

  //   const canvasId = `hmyChart_${index}`;
  //   Chart.register(ChartDataLabels);
  //   const myChart = new Chart(canvasId, {
  //     type: 'bar', // Use 'bar' type
  //     data: {
  //       datasets: [{
  //         label:labels,
  //         data: data,
  //         backgroundColor: ['rgb(60, 146, 186)',
  //         'rgba(255, 99, 132, 0.7)',
  //         'rgba(75, 192, 192, 0.7)',
  //         'rgba(255, 205, 86, 0.7)',
  //         'rgba(54, 162, 235, 0.7)',
  //         'rgba(153, 102, 255, 0.7)',],
  //         borderColor: ['rgb(60, 146, 186)',
  //         'rgba(255, 99, 132, 0.7)',
  //         'rgba(75, 192, 192, 0.7)',
  //         'rgba(255, 205, 86, 0.7)',
  //         'rgba(54, 162, 235, 0.7)',
  //         'rgba(153, 102, 255, 0.7)',],
  //         borderWidth: 1,
  //         barThickness: 20, // Adjust bar thickness as needed
  //       }],
  //       labels:labels // Add labels for the bars
  //     },

  //     // data: {
  //     //   datasets: data,
  //     //   // labels:labels // Add labels for the bars
  //     // },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false,
  //       indexAxis: 'y', // Specify horizontal orientation
  //       plugins: {
  //         tooltip: {
  //           enabled: false // Disable default tooltip
  //         },
  //         datalabels: { // Plugin for displaying data labels
  //           anchor: 'center',
  //           align: 'center',
  //           color: 'white', // Text color
  //           font: {
  //             size: 14 // Font size
  //           },
  //           formatter: function (value: any) { // Format function for the data labels
  //             return value; // Display the value as it is
  //           }
  //         }
  //       },
  //       scales: {
  //         x: { // Configure X scale
  //           beginAtZero: false,
  //           min: 0, // Set minimum value
  //           max: 100,
  //         },
  //         y: {
  //           // Set maximum value // Configure Y scale
  //           grid: {
  //             // color: 'rgba(60,60,60, 1)' // Change the border color for Y scale
  //           },
  //           ticks: {
  //             color: 'black' // Change the color of tick marks on Y scale
  //           }
  //         }
  //       }
  //     }
  //   });
  //   console.log('Chart instance:', myChart);
  // }


  // createhbarChart(index: number, labels: any, data: any): void {
  //   const canvasId = `hmyChart_${index}`;
  //   Chart.register(ChartDataLabels);
  
  //   const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
  
  //   if (!ctx) return; // تأكد من وجود العنصر قبل إنشاء المخطط
  
  //   const myChart = new Chart(ctx, {
  //     type: 'bar',
  //     data: {
  //       labels: labels, // Y-axis labels
  //       datasets: labels.map((label: string, i: number) => ({
  //         label: label, // Individual dataset label for legend
  //         data: labels.map((_, idx) => idx === i ? data[i] : null), // Only show value for matching index
  //         backgroundColor: this.colorarray[i],
  //         borderColor: this.colorarray[i],
  //         borderWidth: 1,
  //         maxBarThickness: 30, // السماح بتكيف سماكة الأعمدة مع حجم الشاشة
  //         minBarLength: 5, // الحد الأدنى لطول العمود
  //       }))
  //     },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false, // يضمن ملاءمة المخطط لحجم الشاشة
  //       indexAxis: 'y',
  //       plugins: {
  //         tooltip: { enabled: true }, // تفعيل التلميحات
  //         datalabels: {
  //           anchor: 'end',
  //           align: 'end',
  //           color: 'white',
  //           font: { size: 14 },
  //           formatter: (value: any) => value || '' // Show value only if present
  //         },
  //         legend: {
  //           onClick: (e, legendItem, legend) => {
  //             const index = legend.chart.data.datasets.findIndex(ds => ds.label === legendItem.text);
  //             if (index === -1) return;
              
  //             const meta = legend.chart.getDatasetMeta(index);
  //             meta.hidden = !meta.hidden;
  //             legend.chart.update();
  //           }
  //         }
  //       },
  //       scales: {
  //         x: { 
  //           beginAtZero: true, // التأكد من بدء القيم من الصفر
  //           suggestedMax: Math.max(...data) + 10, // التكيف مع البيانات تلقائيًا
  //           ticks: { color: 'black' }
  //         },
  //         y: { 
  //           ticks: { color: 'black' }
  //         }
  //       }
  //     }
  //   });
  // }
  

  // createhbarChart(index: number, labels: any, data: any): void {
  //   const canvasId = `hmyChart_${index}`;
  //   Chart.register(ChartDataLabels);
  
  //   const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
  //   if (!ctx) return; // Prevent errors if the canvas is not found
  //   ctx.style.height = `${labels.length * 80}px`; // 🚀 Dynamically adjust height

  //   // ctx.style.height = '600px'; // Set a dynamic height
  
  //   const myChart = new Chart(ctx, {
  //     type: 'bar',
  //     data: {
  //       labels: labels,
  //       datasets: labels.map((label: string, i: number) => ({
  //         label: label,
  //         data: labels.map((_, idx) => idx === i ? data[i] : null),
  //         backgroundColor: this.colorarray[i],
  //         borderColor: this.colorarray[i],
  //         borderWidth: 2,
  //         maxBarThickness: 100, // 🚀 Increase Bar Thickness
  //         barPercentage: 1.0, // 📌 Make bars as wide as possible
  //         categoryPercentage: 1.0, // 📌 Ensure full width is used
  //       }))
  //     },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false, // Allow height adjustments
  //       indexAxis: 'y',
  //       plugins: {
  //         tooltip: { enabled: true },
  //         datalabels: {
  //           anchor: 'end',
  //           align: 'end',
  //           color: 'white',
  //           font: { size: 18 },
  //           formatter: (value: any) => value || ''
  //         },
  //         legend: {
  //           onClick: (e, legendItem, legend) => {
  //             const index = legend.chart.data.datasets.findIndex(ds => ds.label === legendItem.text);
  //             if (index === -1) return;
  //             const meta = legend.chart.getDatasetMeta(index);
  //             meta.hidden = !meta.hidden;
  //             legend.chart.update();
  //           }
  //         }
  //       },
  //       scales: {
  //         x: {
  //           beginAtZero: true,
  //           suggestedMax: Math.max(...data),
  //           ticks: { color: 'black' }
  //         },
  //         y: {
  //           ticks: { color: 'black' }
  //         }
  //       }
  //     }
  //   });
  // }




  

  createhbarChart(index: number, labels: any[], data: number[]): void {
    const canvasId = `hmyChart_${index}`;
    Chart.register(ChartDataLabels);
  
    const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!ctx) return; // Prevent errors if canvas is not found
  
    ctx.style.height = `${labels.length * 50}px`; // 🚀 Auto-adjust height based on labels count
  
    const myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels, // Labels correctly mapped to Y-axis
        datasets: [
          {
            label: 'Values',
            data: data,
            backgroundColor: this.colorarray.slice(0, data.length),
            borderColor: this.colorarray.slice(0, data.length),
            borderWidth: 2,
            maxBarThickness: 40, // ✅ Large bars without overlap
            barPercentage: 1.0, // ✅ Adjust width to fit well
            categoryPercentage: 1.0, // ✅ Ensures full space usage
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
          tooltip: { enabled: true },
          datalabels: { // ✅ عرض القيم داخل الأعمدة
            anchor: 'center',
            align: 'center',
            color: 'white',
            font: { size: 13,weight:'bold' },
            formatter: (value) => value+"%" || ''
          },
          legend: {
            display: false // ✅ Hide legend if not needed
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            suggestedMax: Math.max(...data),
            ticks: { color: 'black' }
          },
          y: {
            ticks: { color: 'black' }
          }
        }
      }
    });
  }
  
  
  



  // createvbarChart(index: number,labels:any,data:any): void {  
  //   const canvasId = `vmyChart_${index}`;
  //   Chart.register(ChartDataLabels);
  //   const myChart = new Chart(canvasId, {
  //     type: 'bar',

  //     data: {
  //       labels: labels, // Labels correctly mapped to Y-axis
  //       datasets: [
  //         {
  //           label: 'Values',
  //           data: data,
  //           backgroundColor: this.colorarray.slice(0, data.length),
  //           borderColor: this.colorarray.slice(0, data.length),
  //           borderWidth: 2,
  //           maxBarThickness: 40, // ✅ Large bars without overlap
  //           barPercentage: 1.0, // ✅ Adjust width to fit well
  //           categoryPercentage: 1.0, // ✅ Ensures full space usage
  //         }
  //       ]
  //     },


  //     // data: {
  //     //   datasets: [{
  //     //     label: '',
  //     //     data: data,
  //     //     backgroundColor: ['rgb(60, 146, 186)',
  //     //     'rgba(255, 99, 132, 0.7)',
  //     //     'rgba(75, 192, 192, 0.7)',
  //     //     'rgba(255, 205, 86, 0.7)',
  //     //     'rgba(54, 162, 235, 0.7)',
  //     //     'rgba(153, 102, 255, 0.7)',],
  //     //     borderColor: ['rgb(60, 146, 186)',
  //     //     'rgba(255, 99, 132, 0.7)',
  //     //     'rgba(75, 192, 192, 0.7)',
  //     //     'rgba(255, 205, 86, 0.7)',
  //     //     'rgba(54, 162, 235, 0.7)',
  //     //     'rgba(153, 102, 255, 0.7)',],
  //     //     borderWidth: 1,
  //     //     categoryPercentage: 0.8,
  //     //     barPercentage: 0.9
  //     //           }],
  //     //   labels: labels
  //     // },
  //     options: {
  //       responsive: true,
  //       maintainAspectRatio: false,
  //       plugins: {
  //         tooltip: {
  //           enabled: false // Disable default tooltip
  //         },

  //         datalabels: { // Plugin for displaying data labels
  //           anchor: 'center',
  //           align: 'center',
  //           color: 'white', // Text color
  //           font: {
  //             size: 14 // Font size
  //           },
  //           formatter: (value: any) => value || ''

  //         },
        
  //         legend: {
  //           display: false // ✅ Hide legend if not needed
  //         }
          
  //       }
  //      ,
  //       scales: {

  //         x: {
  //           grid: {

  //             // color: 'rgba(60,60,60, 1)' // Change the border color for X scale
  //           },
  //           ticks: {
  //             color: 'black' // Change the color of tick marks on X scale
  //           },

  //         },
  //         y: {
  //           beginAtZero: true,
  //           min: 0, // Set minimum value
  //           max: 100,

  //         }
  //       }
  //     }
  //   });
  //   console.log('Chart instance:', myChart);
  // }

  createvbarChart(index: number, labels: any[], data: number[]): void {
    const canvasId = `vmyChart_${index}`;
    Chart.register(ChartDataLabels);
  
    const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!ctx) return;
  
    // ضبط ارتفاع الكانفس بناءً على عدد الأعمدة
    ctx.style.height = `${Math.max(300, labels.length * 50)}px`;
  
    const myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Values',
          data: data,
          backgroundColor: this.colorarray.slice(0, data.length),
          borderColor: this.colorarray.slice(0, data.length),
          borderWidth: 2,
          maxBarThickness: 80, // ✅ زيادة سمك الأعمدة
          barPercentage: 0.9, // ✅ عرض مناسب للأعمدة
          categoryPercentage: 0.9, // ✅ توزيع جيد داخل المحاور
        }]
      },
      options: {
        responsive: true, // ✅ يجعل المخطط متجاوبًا
        maintainAspectRatio: false, // ✅ يسمح له بتغيير الحجم حسب الحاجة
        plugins: {
          tooltip: { // ✅ تفعيل التلميحات
            enabled: true,
            callbacks: {
              // label: (tooltipItem) => `${tooltipItem.dataset.label}: ${tooltipItem.raw}`
            }
          },
          datalabels: { // ✅ عرض القيم داخل الأعمدة
            anchor: 'center',
            align: 'center',
            color: 'white',
            font: { size: 13,weight:'bold' },
            formatter: (value) => value+"%"|| ''
          },
          legend: { display: false } // ✅ عرض وسيلة الإيضاح
        },
        scales: {
          x: {
            ticks: { color: 'black' },
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            min: 0,
            max: Math.max(...data), // ✅ ضبط الحد الأعلى حسب البيانات
            ticks: { color: 'black' },
            grid: { color: 'rgba(0,0,0,0.1)' }
          }
        }
      }
    });
  }
  


  actionplandoughnutChart(index: number,open:any,close:any,underprocess:any): void {
    // const chartContainerId = `chartContainerName_${index}`;
    const canvasId = `actionplandoughnutChart_${index}`;
    Chart.register(ChartDataLabels);
    const myChart = new Chart(canvasId, {
      type: 'doughnut',
      data: {
        datasets: [{
          label: '',
          data: [open, close, underprocess],
          backgroundColor: ['rgb(255,0,0)', 'rgb(60, 146, 186)', 'rgb(255, 160, 0)'
          ],

          borderWidth: 1,

        }],
        labels: ['open', 'close', 'underprocess']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // Crucial for responsiveness
        plugins: {
          tooltip: { enabled: false },
          datalabels: {
            anchor: 'center',
            align: 'center',
            color: 'white',
            font: { size: 14 },
            formatter: (value: any) => `${value}%`
          }
        }
      }
    });
    console.log('Chart instance:', myChart);
  }



  sandtardcompilationdoughnutChart(index: number,data:any): void {
    // const chartContainerId = `chartContainerName_${index}`;
    const canvasId = `sandtardcompilationdoughnutChart_${index}`;
    Chart.register(ChartDataLabels);
    const myChart = new Chart(canvasId, {
      type: 'doughnut',
      data: {
        datasets: [{
          label: '',
          data: data,
          backgroundColor: ['rgb(60, 146, 186)',
            'rgb(255,0,0)',
            'rgb(255, 160, 0)'],
          borderWidth: 1,

        }],
        labels: ['c', 'nc', 'm']
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // Crucial for responsiveness
        plugins: {
          tooltip: { enabled: false },
          datalabels: {
            anchor: 'center',
            align: 'center',
            color: 'white',
            font: { size: 14 },
            formatter: (value: any) => `${value}%`
          }
        }
      }
    });
    console.log('Chart instance:', myChart);
  }

  getActionPlanByAuditid(id,LastAuditIndex){
    this.GeneralService.getActionPlanByAuditid(id).then(res=>{
      return new Promise<any>((resolve, reject) => {
        console.log(res)
        const today = new Date();
      this.ActionPlanOpen= res.filter(x=>x.done == "false" && new Date(x.duedate) < today).length
      this.ActionPlanClose= res.filter(x=>x.done == "true").length
      this.ActionPlanUnderProcess= res.filter(x=>x.done == "false" && new Date(x.duedate) > today).length
      
      this.ActionPlanOpen= parseFloat(Number(Number(this.ActionPlanOpen *100 ) / Number(res.length)).toFixed(1))
      this.ActionPlanClose= parseFloat(Number(Number(this.ActionPlanClose *100 ) / Number(res.length)).toFixed(1))
      this.ActionPlanUnderProcess= parseFloat(Number(Number(this.ActionPlanUnderProcess *100 ) / Number(res.length)).toFixed(1))

      console.log(this.ActionPlanOpen,"ActionPlanOpen")
      console.log(this.ActionPlanClose,"ActionPlanClose")
      console.log(this.ActionPlanUnderProcess,"ActionPlanUnderProcess")
this.actionplandoughnutChart(LastAuditIndex,this.ActionPlanOpen,this.ActionPlanClose,this.ActionPlanUnderProcess)
      }).catch(error => {
        // This block is executed if there is an error with the API call
        console.error("API error:", error);
        // Handle the error as needed, e.g., display an error message to the user
      });
    })

  }





}
